import type { Resource } from '../../';
export const forms_error_isState: Resource = {"default":"You must select a {name}."};
